import React, { useState, useEffect } from 'react'
import { Row, Col, Input, Form, SelectPicker, DatePicker } from 'rsuite'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'
import moment from 'moment'

export default function ProjectBudgetPlanReportForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  handelPreview,
  clearValue,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [startDates, setStartDates] = useState(null)

  useEffect(() => {
    console.log('schemaschema ', schema)
    if (!clearValue) {
    }
  }, [clearValue])

  const Styles = {
    labelStyle: {
      marginTop: '5px',
      padding: '8px',
      textAlign: 'right',
    },
    inputStyle: {
      marginTop: '5px',
      padding: '8px',
    },
  }

  return (
    <>
      <Form id="mainContainer">
        <Row>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.budgetYear.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <Controller
              name={schema.budgetYear.name}
              control={control}
              render={(props) => {
                return (
                  <SelectPicker
                    data={schema.budgetYear.options}
                    value={props.value}
                    block
                    placeholder={`เลือก${schema.budgetYear.label}`}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.approveDateEnd.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <Controller
                  key={schema.approveDateEnd.name}
                  name={schema.approveDateEnd.name}
                  control={control}
                  defaultValue={
                    schema.approveDateEnd.value
                      ? moment(schema.approveDateEnd.value, DATE_PICKER_FORMAT).toDate()
                      : null
                  }
                  // rules={isValidators(schema.approveDateEnd.validators)}
                  render={(props) => {
                    return (
                      <DatePicker
                        format="DD/MM/YYYY"
                        locale={LOCAL_DAY_TH}
                        block
                        value={startDates}
                        onChange={(value) => {
                          const date = moment(value).format(DATE_PICKER_FORMAT)
                          props.onChange(value)
                          setStartDates(value)
                        }}
                        // disabledDate={(date) =>
                        //   endDates && moment(endDates).isBefore(date, new Date())
                        // }
                      />
                    )
                  }}
                />
          </Col>
        </Row>
        <Row>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.department.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <Controller
              name={schema.department.name}
              control={control}
              render={(props) => {
                return (
                  <SelectPicker
                    data={schema.department.options}
                    value={props.value}
                    block
                    placeholder={`เลือก${schema.department.label}`}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}></Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}></Col>
        </Row>
      </Form>
    </>
  )
}
